import { useCurrentPath } from '@/hooks/general/useCurrentPath/useCurrentPath';
import { useLangSwitcherStore } from './langSwitcherStore';

export const useIsLangSwitcherDisabled = (): boolean => {
    const currentPath = useCurrentPath();
    const pathname = currentPath.pathname;
    const { forceEnabled } = useLangSwitcherStore();

    if (forceEnabled) {
        return false;
    }

    const disabledPaths = ['/compensation'];

    return disabledPaths.some((path) => pathname.startsWith(path));
};
